export type IProgram = {
	id: string;
	_id: string;
	name: string;
};

export interface ProgramParameters {
	eligibility: boolean;
	consent: boolean;
	maxBeneficiaries: number;
	durationInWeeks: number;
	maxYearlyEarnings: number;
	budgetLimit: number;
	baseIncentiveNegative: number;
	baseIncentivePositive: number;
	biVisitIncrementNegative: number;
	repetitionPerSteps: number;
	eligibilityConfirmationIntervalDays?: number;
	_id?: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	durationConfig?: any;
}

export interface ProgramFeatures {
	enableJournal?: boolean;
	enableRewards?: boolean;
	enableAutomatedNotifications?: boolean;
	enableActivityAlerts?: boolean;
	enableCallManagement?: boolean;
	allowEnrollmentPause?: boolean;
	allowIncentiveInvalidation?: boolean;
	eventBasedRewards?: boolean;
}

export interface ProgramVisibleTabs {
	showWeeklyCalendar?: boolean;
	showDailyJourney?: boolean;
	showClinicalInformation?: boolean;
}

export interface Program {
	_id: string;
	id: string;
	accountId: string;
	name: string;
	type: "Stim" | "OUD";
	status: "ACTIVE" | "INACTIVE";
	multiTreatmentPlan: boolean;
	treatmentPlanChangeAllowed: boolean;
	treatmentPlan?: string;
	orgUnitId?: string[];
	parameters: ProgramParameters;
	createdBy: string;
	createdAt: string;
	updatedAt: string;
	cmRoles?: string[];
	additionalStaffRoles?: string[];
	payers?: string[];
	requirePayerPlanReviewOnReconfirm?: boolean;
	incentiveOnDemand?: boolean;
	onDemandIncentiveMin?: number;
	onDemandIncentiveMax?: number;
	features?: ProgramFeatures;
	visibleTabs?: ProgramVisibleTabs;
}

export interface ProgramRequest {
	accountId: string;
	name: string;
	type: "Stim" | "OUD";
	status: "ACTIVE" | "INACTIVE";
	multiTreatmentPlan: boolean;
	treatmentPlanChangeAllowed: boolean;
	treatmentPlan?: string;
	orgUnitId?: string[];
	parameters: ProgramParameters;
	createdBy: string;
	cmRoles?: string[];
	additionalStaffRoles?: string[];
	payers?: string[];
	requirePayerPlanReviewOnReconfirm?: boolean;
	incentiveOnDemand?: boolean;
	onDemandIncentiveMin?: number;
	onDemandIncentiveMax?: number;
	features?: ProgramFeatures;
	visibleTabs?: ProgramVisibleTabs;
}

export type Params = {
	accountId: string;
	userId?: string;
};

export enum IncentiveTypes {
	GC = "GC",
	PPC = "PPC",
}
